import {createAction, props} from "@ngrx/store";
import {MaintenanceInfo} from "../../maintenance/banner/maintenance-banner.component";

export class OtherActions {
	static readonly SET_MAINTENANCE_INFO = createAction('SET_MAINTENANCE_INFO', props<{ maintenanceInfo: MaintenanceInfo }>());
}
